<h2 mat-dialog-title class="overwrite-margin">{{ this.data.isEdit ? "Edit" : "Create" }} component type</h2>

<div class="form-container type-dialog">
  <form [formGroup]="componentTypeForm">
    <div class="form-field-container">
      <span class="form-field-header">COMPONENT TYPE NAME<span style="color: #de4020">*</span></span>
      <mat-form-field appearance="outline" class="name">
        <input id="input-component-type-name" matInput formControlName="name" placeholder="Component type name" />
      </mat-form-field>
    </div>
    <div class="form-field-container">
      <span class="form-field-header mt1">DESCRIPTION</span>
      <mat-form-field appearance="outline" class="description">
        <input
          id="input-component-type-description"
          matInput
          formControlName="description"
          placeholder="E.g. My Component Type"
        />
      </mat-form-field>
    </div>
    @if (!isHumidity) {
    <h3 style="margin-top: 24px; margin-bottom: 3px">Available / In use configuration</h3>
    <p>Input the expected minimum and maximum distance to the object that are target for measurement.</p>
    <div class="grid">
      <div class="form-field-container space-between">
        <span class="form-field-header mt1">MIN DISTANCE (MM)<span style="color: #de4020">*</span></span>
        <mat-form-field appearance="outline" style="width: 150px">
          <mat-select
            id="select-min-distance"
            formControlName="mindistance"
            placeholder="Select distance"
            (selectionChange)="minChange()"
          >
            @for (value of minValues; track value) {
            <mat-option id="option-min-{{ value }}" value="{{ value }}">
              {{ value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-field-container ml mt1">
        <span class="form-field-header">MAX DISTANCE (MM)<span style="color: #de4020">*</span></span>
        <mat-form-field appearance="outline" style="width: 150px">
          <mat-select
            id="select-max-distance"
            formControlName="maxdistance"
            placeholder="Select distance"
            (selectionChange)="maxChange()"
          >
            @for (value of maxValues; track value) {
            <mat-option id="option-max-{{ value }}" value="{{ value }}">
              {{ value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }

    <div class="separator"></div>
    <header>
      <svg-icon src="/assets/images/icon_incidents.svg" [class]="'icon'"></svg-icon>
      <h3>Incidents</h3>
    </header>
    @if (isHumidity) {
    <mat-slide-toggle id="toggle-humidity-warning" formControlName="isHumidityWarningActive" style="font-weight: 600">
      <svg-icon src="/assets/images/icon-16-humidity.svg"></svg-icon> Humidity
    </mat-slide-toggle>
    <p>Highlight components when humidity is above set threshold</p>
    <span class="form-label mt1">Humidity</span>
    <div class="form-icon-container">
      <mat-form-field class="select-field inverted" appearance="outline">
        <mat-select formControlName="humidityThreshold">
          <mat-option value="10">10%</mat-option>
          <mat-option value="20">20%</mat-option>
          <mat-option value="30">30%</mat-option>
          <mat-option value="40">40%</mat-option>
          <mat-option value="50">50%</mat-option>
          <mat-option value="60">60%</mat-option>
          <mat-option value="70">70%</mat-option>
          <mat-option value="80">80%</mat-option>
          <mat-option value="90">90%</mat-option>
        </mat-select>
      </mat-form-field>
      <svg-icon
        src="/assets/images/icon-16-help.svg"
        [class]="'icon-tool-tip'"
        matTooltip="Humidity threshold for triggering humidity incidents"
      ></svg-icon>
    </div>
    } @if (isHumidity) {
    <div class="separator short"></div>
    }
    <mat-slide-toggle id="toggle-shock-warning" formControlName="isShockWarningActive" style="font-weight: 600">
      <svg-icon src="/assets/images/icon-16-shock.svg"></svg-icon> Shock
    </mat-slide-toggle>
    <p>Highlight components when exposed to a shock above threshold</p>
    <span class="form-label mt1">NSE</span>
    <div class="form-icon-container">
      <mat-form-field class="select-field inverted" appearance="outline">
        <mat-select formControlName="shockThreshold" (selectionChange)="onShockValueChange()">
          @for (shockValue of shockValues; track shockValue) {
          <mat-option value="{{ shockValue }}"> {{ shockValue }} </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <svg-icon
        src="/assets/images/icon-16-help.svg"
        [class]="'icon-tool-tip'"
        matTooltip="Normalized shock energy threshold for triggering shock incidents"
      ></svg-icon>
    </div>
    <div class="separator"></div>

    <!-- Service Locations Section (Only for Utilization) -->
    @if (isUtilization) {
    <div class="separator"></div>
    <header>
      <mat-icon class="icon">place</mat-icon>
      <h3>Service Locations</h3>
    </header>
    <p>Configure geofence-based service locations for this component type</p>
    @if (isLoadingLocations) {
    <div class="service-locations-loading">Loading service locations...</div>
    } @if (!isLoadingLocations && serviceLocations.length === 0) {
    <div class="service-locations-empty">No service locations configured</div>
    } @if (!isLoadingLocations && serviceLocations.length > 0) {
    <mat-list>
      @for (location of serviceLocations; track location) {
      <mat-list-item>
        <div class="service-location-item">
          <div>
            <strong>{{ location.name }}</strong>
            @if (location.description) {
            <p class="service-location-description">
              {{ location.description }}
            </p>
            }
          </div>
          <button
            mat-icon-button
            color="warn"
            (click)="removeServiceLocation(location)"
            matTooltip="Remove service location"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
      }
    </mat-list>
    } @if (!isLoadingLocations) {
    <button mat-flat-button color="primary" (click)="addServiceLocation()" class="add-location-btn">
      <mat-icon>add</mat-icon>
      Add Service Location
    </button>
    }
    <div class="separator"></div>
    }
  </form>
</div>
<mat-dialog-actions>
  @if (this.data.isEdit) {
  <div style="width: 25%">
    <button
      mat-flat-button
      [disabled]="deleteDisabled()"
      [mat-dialog-close]="'delete'"
      [ngStyle]="{ 'background-color': deleteDisabled() ? '#777777' : '#f44336', color: 'white' }"
    >
      Delete
    </button>
  </div>
  }
  <div [ngStyle]="{ width: this.data.isEdit ? '75%' : '100%', 'text-align': 'right' }">
    <button id="btn-component-type-cancel" mat-flat-button [disabled]="createClicked" [mat-dialog-close]="'cancel'">
      Cancel
    </button>
    @if (this.data.isEdit) {
    <button
      id="btn-component-type-update"
      mat-flat-button
      [disabled]="createClicked || updateDisabled()"
      [class.spinner]="createClicked"
      (click)="onClick()"
      mat-primary
      color="primary"
      [mat-dialog-close]="'update'"
    >
      Update
    </button>
    } @if (!this.data.isEdit) {
    <button
      id="btn-component-type-create"
      mat-flat-button
      [disabled]="createClicked || invalidForm()"
      [class.spinner]="createClicked"
      (click)="onClick()"
      mat-primary
      color="primary"
      [mat-dialog-close]="'create'"
    >
      Create
    </button>
    }
  </div>
</mat-dialog-actions>
